export default __webpack_public_path__ + "assets/images/4ad6ec8eb1c074c1bdeffc1388554295.png";